export const hasFilter = (activeFilters = {}) =>
  Object.keys(activeFilters || {}).find((k) => !['page', 'pageSize', 'sortBy', 'sortDir', 'search', 'searchParams'].includes(k));
